import React, { useContext, useEffect, useReducer } from "react";
import IAppState from "../interfaces/IAppState";
import { appReducer } from "../reducers/appReducer";
import { getSettings } from "../services/settingsService";

export interface IAppContext {
    state: IAppState;
    dispatch: React.Dispatch<any>;
}

const AppContext = React.createContext<IAppContext>({
    state: {},
    dispatch: () => null
});

export const AppProvider = ({ children, isDarkTheme, backgroundColor, color }: any) => {
    const [state, dispatch] = useReducer(appReducer, {
        showLoader: false, isDarkTheme, backgroundColor, color,
        reportFilter: getSettings().reportFilter ?? "ALL", onlyActiveReports: false
    });
    const contextValue = { state, dispatch };

    useEffect(() => {
        dispatch({ type: "SET_THEME_VARIANT", isDarkTheme });
    }, [isDarkTheme]);

    useEffect(() => {
        dispatch({ type: "SET_BGCOLOR", color: backgroundColor });
    }, [backgroundColor]);

    useEffect(() => {
        dispatch({ type: "SET_COLOR", color });
    }, [color]);

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    const context = useContext(AppContext);
    return context;
};
